const BASE = "/employee_transfers";

export const EMPLOYEE_TRANSFER_API_PATHS = {
  validate: (token: string) => `${BASE}/${encodeURIComponent(token)}`,
  requestOtp: (token: string) => `${BASE}/${encodeURIComponent(token)}/request_otp`,
  verifyOtp: (token: string) => `${BASE}/${encodeURIComponent(token)}/verify_otp`,
  refuse: (token: string) => `${BASE}/${encodeURIComponent(token)}/refuse`,
  requestResend: (token: string) => `${BASE}/${encodeURIComponent(token)}/request_resend`,
} as const;
